<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <el-row>
        <el-col :span="24">
          <el-form class="searchForm" ref="form" :model="form" label-width="90px" style="margin-top: 20px">
            <el-col :md="12" :lg="8" :xl="6">
              <el-form-item label="申请时间">
                <el-date-picker style="width: 100%" type="daterange" :default-time="['00:00:00', '23:59:59']" start-placeholder="开始日期" end-placeholder="结束日期" v-model="form.applyTimeRange" format="yyyy年MM月dd日" value-format="yyyy-MM-dd H:m:s"></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :md="12" :lg="8" :xl="8">
              <el-form-item label="稿件标题">
                <el-input placeholder="模糊检索" v-model="form.title"></el-input>
              </el-form-item>
            </el-col>

            <el-col :md="12" :lg="4" :xl="6">
              <el-form-item label="稿件作者">
                <el-input placeholder="模糊检索" v-model="form.author"></el-input>
              </el-form-item>
            </el-col>

            <el-col :md="12" :lg="4" :xl="4">
              <div style="float: right">
                <el-button type="primary" @click="loadData">搜索</el-button>
              </div>
            </el-col>
          </el-form>

          <div style="padding: 20px 0">
            <el-button type="primary" :disabled="!flag" @click="exportXLS">导出记录</el-button>
            <el-button type="warning" :disabled="!flag" @click="setStatus(1)">批量登记状态（待开具）</el-button>
            <el-button type="danger" :disabled="!flag" @click="setStatus(2)">批量登记状态（开具中）</el-button>
          </div>

          <el-table ref="tableData" :data="tableData" @select-all="selAll" @selection-change="selChange" stripe style="width: 100%">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="createTime" align="center" label="申请时间" width="120">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm") }}
              </template>
            </el-table-column>

            <el-table-column prop="companyName" label="发票抬头"></el-table-column>
            <el-table-column prop="regNumber" label="开票税号"></el-table-column>
            <el-table-column prop="money" label="开票金额" width="70"></el-table-column>
            <el-table-column prop="money" label="开票内容">
              <template slot-scope="scope"> <el-tag type="primary">出版费</el-tag> {{ scope.row.title }} </template>
            </el-table-column>
            <el-table-column prop="email" label="传递邮箱"></el-table-column>
            <el-table-column prop="title" label="状态">
              <template slot-scope="scope">
                <el-tag type="primary" v-if="scope.row.isIssue == 1">待开具</el-tag>
                <el-tag type="warning" v-else-if="scope.row.isIssue == 2">正在开具中</el-tag>
                <el-tag type="success" v-else-if="scope.row.isIssue == 3">已开具</el-tag>
                <el-tag type="danger" v-else-if="scope.row.isIssue == 4">已作废</el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="pt" align="center" label="操作" width="140">
              <template slot-scope="scope">
                <el-button type="default" size="mini" @click="openDrawer(scope.row.invoiceId, 'info')">查看申请信息</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin: 20px 0 0 -5px">
            <el-pagination background layout="total,sizes,prev, pager, next,jumper" :total="total" :page-sizes="[20, 30, 50, 100]" :page-size="pageSize" :current-page="curPage" @size-change="pageSizeChange" @current-change="pageChange"> </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-drawer :title="drawerTitle" :visible.sync="drawer" :direction="'rtl'" :size="700" :destroy-on-close="true" :wrapperClosable="false">
      <InvoiceEdit v-if="drawerAction == 'edit'" :invoiceId="invoiceId" @close="closeDrawer" @submitSuccess="editSuccess"></InvoiceEdit>
      <InvoiceInfo v-if="drawerAction == 'info'" :onlyShow="true" :invoiceId="invoiceId" @close="closeDrawer" @intoEditing="intoEditing"></InvoiceInfo>
    </el-drawer>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import InvoiceInfo from "@/components/InvoiceInfo.vue"
import InvoiceEdit from "@/components/InvoiceEdit.vue"
import financeApi from "@/api/finance"
import systemApi from "@/api/system"
import attachUtil from "@/utils/attachUtil"
export default {
  components: { PageHeader, InvoiceEdit, InvoiceInfo },
  data() {
    return {
      tabActive: "first",
      headLinks: [{ path: "", title: "已开发票记录" }],
      form: {
        author: "",
        isIssue: 3,
        applyTimeRange: [],
        title: "",
      },
      flag: false,

      curPage: 1,
      pageSize: 20,
      tableData: [],
      total: 0,

      drawer: false,
      drawerTitle: "填写发票信息",
      drawerAction: "add",
      invoiceId: null,
    }
  },

  mounted() {
    this.loadData()
  },

  methods: {
    loadData() {
      this.tableData = []
      financeApi.getInvoiceListForPage(this.curPage, this.pageSize, this.form).then((res) => {
        this.tableData = res.rows
        this.total = res.total
      })
    },

    closeDrawer() {
      this.drawer = false
    },

    openDrawer(id, action) {
      this.invoiceId = id
      this.drawer = true
      this.drawerAction = action
      this.drawerTitle = this.drawerAction == "edit" ? "编辑开票信息" : "查看开票信息"
    },

    editSuccess() {
      this.loadData()
      this.getStat()
    },

    intoEditing(invoiceId) {
      this.invoiceId = invoiceId
      this.drawer = true
      this.drawerAction = "edit"
      this.drawerTitle = "编辑开票信息"
    },

    getStat() {
      systemApi.getStat().then((res) => {
        if (res.code == 0) {
          this.$store.commit("app/SET_FINANCESTAT", res.data.financeHomeInfoVO)
        }
      })
    },

    selAll() {
      this.flag = this.$refs.tableData.selection.length > 0
    },
    selChange() {
      this.flag = this.$refs.tableData.selection.length > 0
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.pageChange(1)
    },

    pageChange(curPage) {
      this.curPage = curPage
      this.loadData()
    },

    setStatus(status) {
      let selRows = this.$refs.tableData.selection
      let ids = []
      selRows.forEach((element) => {
        ids.push(element.invoiceId)
      })
      financeApi.setStatus(ids, status).then((res) => {
        if (res.code == 0) {
          this.$notify({
            title: "成功",
            message: res.msg,
            type: "success",
          })
          this.getStat()
          this.loadData()
        } else if (res.code == 1) {
          this.$notify({
            title: "失败",
            message: res.msg,
            type: "error",
          })
        }
      })
    },

    exportXLS() {
      let selRows = this.$refs.tableData.selection
      let ids = []
      selRows.forEach((element) => {
        ids.push(element.invoiceId)
      })

      financeApi.exportXLSForInvioce(ids).then((res) => {
        if (res.type != "application/octet-stream") {
          this.$alert("下载失败!", "错误", {
            confirmButtonText: "确定",
          })
        } else {
          attachUtil.download(res, "已开发票记录表.xls")
        }
      })
    },
  },
}
</script>
